import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import SignupAndOnboarding from './pages/signup-and-onboarding';
import LandingPage from './pages/landing-page';
import PredictiveAnalysis from './pages/predictive-analysis';
import Dashboard from './pages/dashboard';
import BusinessModelCanvas from './pages/business-model-canvas';
import BusinessModelCanvasReportGenerator from './pages/business-model-canvas-report-generator';
import GoalIntelligence from './pages/goal-intelligence';
import ReportsDashboard from './pages/reports-dashboard';
import SuperAdminLogin from './pages/super-admin-login';
import SuperAdminDashboard from './pages/super-admin-dashboard';
import ClientManagementPanel from './pages/client-management-panel';
import SubscriptionPlansManagement from './pages/subscription-plans-management';
import BillingManagement from './pages/billing-management';
import AllClientsManagement from './pages/all-clients-management';
import ClientProfileDetails from './pages/client-profile-details';
import ActivityLogsMonitor from './pages/activity-logs-monitor';
import SubscriptionPricingManagement from './pages/subscription-pricing-management';
import PaymentManagementCenter from './pages/payment-management-center';
import SuperAdminAllPlans from './pages/super-admin-all-plans';
import SuperAdminCreatePlan from './pages/super-admin-create-plan';
import SuperAdminPlanFeaturesMatrix from './pages/super-admin-plan-features-matrix';
import SuperAdminPricingRules from './pages/super-admin-pricing-rules';
import PaymentHistoryManagement from './pages/payment-history-management';
import TransactionGatewayTracking from './pages/transaction-gateway-tracking';
import RefundApprovalWorkflow from './pages/refund-approval-workflow';
import InvoiceGenerationCenter from './pages/invoice-generation-center';
import RefundManagementCenter from './pages/refund-management-center';
import InvoiceManagementHub from './pages/invoice-management-hub';
import GeneratedReportsManagement from './pages/generated-reports-management';
import ModuleAnalyticsDashboard from './pages/module-analytics-dashboard';
import UserBehaviorAnalyticsCenter from './pages/user-behavior-analytics-center';
import ActivityMonitoringCommandCenter from './pages/activity-monitoring-command-center';
import MindMapping from './pages/mind-mapping';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup-and-onboarding" element={<SignupAndOnboarding />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/predictive-analysis" element={<PredictiveAnalysis />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/business-model-canvas" element={<BusinessModelCanvas />} />
        <Route path="/business-model-canvas-report-generator" element={<BusinessModelCanvasReportGenerator />} />
        <Route path="/goal-intelligence" element={<GoalIntelligence />} />
        <Route path="/reports" element={<ReportsDashboard />} />
        <Route path="/billing" element={<BillingManagement />} />
        <Route path="/super-admin-login" element={<SuperAdminLogin />} />
        <Route path="/super-admin-dashboard" element={<SuperAdminDashboard />} />
        <Route path="/client-management-panel" element={<ClientManagementPanel />} />
        <Route path="/super-admin/subscriptions/plans" element={<SubscriptionPlansManagement />} />
        <Route path="/super-admin/clients" element={<AllClientsManagement />} />
        <Route path="/client-profile-details" element={<ClientProfileDetails />} />
        <Route path="/activity-logs-monitor" element={<ActivityLogsMonitor />} />
        <Route path="/super-admin/clients/activity" element={<ActivityLogsMonitor />} />
        <Route path="/subscription-pricing-management" element={<SubscriptionPricingManagement />} />
        <Route path="/payment-management-center" element={<PaymentManagementCenter />} />
        <Route path="/super-admin-all-plans" element={<SuperAdminAllPlans />} />
        <Route path="/super-admin-create-plan" element={<SuperAdminCreatePlan />} />
        <Route path="/super-admin/subscriptions/create" element={<SuperAdminCreatePlan />} />
        <Route path="/super-admin-plan-features-matrix" element={<SuperAdminPlanFeaturesMatrix />} />
        <Route path="/super-admin-pricing-rules" element={<SuperAdminPricingRules />} />
        <Route path="/super-admin/payments/history" element={<PaymentHistoryManagement />} />
        <Route path="/super-admin/payments/transactions" element={<TransactionGatewayTracking />} />
        <Route path="/refund-approval-workflow" element={<RefundApprovalWorkflow />} />
        <Route path="/invoice-generation-center" element={<InvoiceGenerationCenter />} />
        <Route path="/super-admin/payments/refunds" element={<RefundManagementCenter />} />
        <Route path="/super-admin/payments/invoices" element={<InvoiceManagementHub />} />
        <Route path="/super-admin/reports/generated" element={<GeneratedReportsManagement />} />
        <Route path="/super-admin/reports/analytics" element={<ModuleAnalyticsDashboard />} />
        <Route path="/user-behavior-analytics-center" element={<UserBehaviorAnalyticsCenter />} />
        <Route path="/activity-monitoring-command-center" element={<ActivityMonitoringCommandCenter />} />
        <Route path="/mind-mapping" element={<MindMapping />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
